import KeyValue from './KeyValue.component';

export default KeyValue;
